import { useHistory } from 'react-router-dom';
import { LoginFormValues } from '../../../components/LoginForm/useLoginForm';
import PATHS from '../../../routes/routes.const';
import api from '../../../services/api';
import { OAuthConsentLocationState } from '../pages/OAuthConsentPage';
import useOAuthRequestError from './useOAuthRequestError';

interface UseOAuthLoginParams {
  onExpired: (errorMessage: string) => void;
}

interface UseOAuthLoginReturn {
  handleLogin: (values: LoginFormValues) => Promise<void>;
}

const useOAuthLogin = (
  oauthRequestId: string,
  { onExpired }: UseOAuthLoginParams,
): UseOAuthLoginReturn => {
  const handleRequestError = useOAuthRequestError(onExpired);
  const history = useHistory();

  const handleLogin = async (values: LoginFormValues) => {
    const response = await api.oauthLogin({
      email: values.email,
      password: values.password,
      oauth_request_id: oauthRequestId,
    });

    if (response.ok && response.data?.redirect_to) {
      window.location.href = response.data.redirect_to;
      return;
    }

    if (response.ok && response.data?.requires_consent) {
      const state: OAuthConsentLocationState = {
        oauthRequestId: response.data.oauth_request_id || '',
        clientName: response.data.client_name || '',
        scopes: response.data.scopes || [],
      };
      history.push(PATHS.public.oauthConsent.path, state);
      return;
    }

    handleRequestError(response);
  };

  return { handleLogin };
};

export default useOAuthLogin;
